import angular from 'angular';
import { ActionBarPosition } from './action-bar-position.directive';
import { QuantityInput } from './quantity-input.directive';
import { FocusOnDirectiveModule } from './focus-on/focus-on.module';
export var DirectivesModule = angular
    .module('app.directives', [
    FocusOnDirectiveModule,
])
    .directive('actionBarPosition', ActionBarPosition)
    .directive('qtyInput', QuantityInput)
    .name;
//# sourceMappingURL=directives.module.js.map